import React, { ReactElement } from "react";
import { Field, Colors } from "@lib/shared/types";
import { useForm } from "../hooks/useForm";
import { Classes } from "@components/shared/form";
import OtpForm from "@components/shared/form/OtpForm";
import styles from "@components/shared/form/styles.module.scss";

type UseFormReturn = ReturnType<typeof useForm>;

interface OtpStepProps {
    showOtp: boolean | undefined;
    fieldsData: UseFormReturn["fieldsData"];
    colors?: Colors;
    classes?: Classes;
    isLoading: boolean | undefined;
    operation: UseFormReturn["operation"];
    otp: UseFormReturn["otp"];
    handleFieldChange: UseFormReturn["handleFieldChange"];
}

export default function OtpStep({
    showOtp,
    fieldsData,
    colors,
    classes,
    isLoading,
    operation,
    otp,
    handleFieldChange,
}: OtpStepProps): ReactElement {
    return (
        <div className={styles["step"]}>
            <div>
                {/* otp step */}
                <div className={styles["extra-step-inner"]}>
                    {showOtp && (
                        // [@todo handle logic to be comptable with old form since otp and operation logic does not exist in old form]
                        <OtpForm
                            phoneNumber={fieldsData?.phoneNumber.value}
                            colors={colors}
                            classes={classes}
                            isLoading={
                                !!(isLoading || operation?.loadingBuyers)
                            }
                            otp={otp}
                            handleFieldChange={
                                handleFieldChange as (
                                    field: Pick<Field, "mask" | "codeName">,
                                    val: string,
                                ) => void
                            }
                        />
                    )}
                </div>
                {/* otp step */}
            </div>
        </div>
    );
}
